import React from "react";
import {Redirect,useSearch} from "wouter";
export function LegacyJobsRedirect(){
 const params=new URLSearchParams(useSearch()),id=params.get("job")||params.get("maintenancePay");
 return <Redirect to={`/maintenance/jobs/all${id?`?job=${encodeURIComponent(id)}${params.has("maintenancePay")?"&pay=1":""}`:""}`}/>;
}
